export { PreloaderComponent } from './preloader.component';
